import * as api from './authrep-verify-api';
import * as MsgBarActions from '../../system-shared/message-bar-action-creator';
import { setAuthRepData } from '../../../modules/signup/signup-action-creator';
import history from '../../../../history';

export const verifyAuthRep = (pin, encryptedInvitationId) => (dispatch) => (
  api.verifyAuthRep(pin, encryptedInvitationId)
    .then(
      (response) => {
        dispatch(setAuthRepData({
          encryptedInvitationId,
          pin,
          email: response.data.arEmail,
          facilityHomeId: response.data.facilityHomeId,
        }));
        history.push('/create-account');
      })
    .catch((axiosResponse) => {
      const error = axiosResponse.response;
      if (error.status === 404 || error.status === 500) {
        dispatch(MsgBarActions.showErrorMessage('signUpVerifyIdentityFailure'));
      }

      if (error.status === 400) {
        dispatch(MsgBarActions.showErrorMessage(error.data.message));
      }
    })
);
